export default s => {
  if (!s || s.length === 0) return '';
  const words = s.match(/[a-z]+/gi);
  return words.map(word => word.charAt(0).toUpperCase() + word.substring(1).toLowerCase()).join('');
};
